// app/javascript/controllers/toggle_isrc_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  toggle(event) {
    if (event.target.checked) {
      this.fieldTarget.classList.remove('hidden')
    } else {
      this.fieldTarget.classList.add('hidden')
    }
  }
}
